import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";

import Styles from "components/open/LegacyHeader.module.scss";
import Logo from "assets/img/simbolo.png";
import { Heart } from "components/icons/Heart";
import { Container } from "components/grid/Container";

class LegacyHeader extends Component {
  constructor (props) {
    super(props);

    this.state = {};

    this.menu = [
      {
        url: "https://superbox.glambox.com.br",
        name: "Superbox"
      },
      {
        url: "https://glambox.com.br/revista",
        name: "MAG"
      },
      {
        url: "https://glambox.com.br/faq",
        name: "FAQ"
      }
    ];
  }

  render () {
    return (
      <div className={Styles["header"]}>
        <Container className={"mb-0"}>
          <div className={Styles["header__container"]}>
            <button className={Styles["header__hamburger-menu"]}>
              <span></span>
            </button>
            
            <a href={"https://glambox.com.br"} target={"_blank"} className={Styles["header__logo"]}>
              <img src={Logo} alt={""}/>
            </a>

            <ul className={Styles["header__menu"]}>
              {(() => {
                return this.menu.map((item, key) => {
                  return (
                    <li key={key}>
                      <a href={item.url}>{item.name}</a>
                    </li>
                  );
                });
              })()}
            </ul>

            <div className={Styles["header__spacer"]}/>

            <ul className={Styles["header__menu"]}>
              <li>
                <a href={"https://minha.glambox.com.br"}>
                  Login
                </a>
              </li>
              <li>
                <a href={"https://glambox.com.br#planos"} className={"btn btn-light-pink"} style={{padding: "0 3rem"}}>
                  Assine!
                </a>
              </li>
            </ul>

            <a href={"https://glambox.com.br#planos"} target={"_blank"} className={Styles["header__heart"]}>
              <Heart size={"100%"}/>
            </a>
          </div>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ui: state.ui
});

LegacyHeader = connect(mapStateToProps)(LegacyHeader);

export {
  LegacyHeader
};
